export const descriptionTexts = [
  "Не отказывайте себе в выборе: отдыхайте сами и радуйте близких!",
  "Мы будем рады вас видеть и слышать!"
];

export const mainContactsInfo = [
  { icon: 'location.svg', text: 'Минск, Старовиленская, 100', href: ' https://yandex.by/maps/-/CCUyJYAR2A' },
  { icon: 'location.svg', text: 'Минск, Старовиленская, 131', href: 'https://yandex.by/maps/-/CCU7UUrf9C' },
  { icon: 'location.svg', text: 'Минск, Машерова, 54', href: 'https://yandex.by/maps/-/CCU7UUr1oD' },
  { icon: 'location.svg', text: 'Минск, Первомайская, 14', href: 'https://yandex.by/maps/-/CCU7UUvikD' },
  { icon: 'location.svg', text: 'Минск, Толбухина, 10A', href: 'https://yandex.by/maps/-/CCU7UUvGOA' },
  { icon: 'location.svg', text: 'Минск, Веры Хоружей, 29', href: 'https://yandex.by/maps/-/CDVHVCLV' },
  { icon: 'location.svg', text: 'Минск, Богдановича, 128', href: 'https://yandex.by/maps/-/CDVHVC4a' },
];

export const socialIcons = [
  { src: '/icons/instagram.svg', href: 'https://www.instagram.com/oldmouse.by', alt: 'Insta logo', width: 30, height: 30 },
  { src: '/icons/tt.svg', href: 'https://www.tiktok.com/@questminsk', alt: 'TT logo', width: 35, height: 35 },
  { src: '/icons/vk.svg', href: 'https://vk.com/oldmouseminsk', alt: 'VK logo', width: 35, height: 35 },
];
